import type { MarketsApi } from "@/v2/api/metadata/markets";
import type { OutcomesApi } from "@/v2/api/metadata/outcomes";
import type { BackofficeContext } from "@/v2/framework/context/types";
import type { DialogConfig } from "@/v2/framework/dialog/types";
import { readApiData } from "@/v2/api/response";
import { createOutcomesTab } from "../outcomes/tab";
import { createFeedConfigTab } from "./tabs/feed-config";
import { createFeedMappingTab } from "./tabs/feed-mapping";
import { createConfigurationTab } from "./tabs/configuration";
import { limitsTab } from "./tabs/limits";
import { createLiveTab } from "./tabs/live";
import { createMainTab } from "./tabs/main";
import { createPrematchTab } from "./tabs/prematch";
import { createTranslationsTab } from "./tabs/translations";

export function createEditDialog(options: {
  ctx: BackofficeContext;
  marketsApi: MarketsApi;
  outcomesApi: OutcomesApi;
}): DialogConfig {
  const { ctx, marketsApi, outcomesApi } = options;

  return {
    id: "edit-market",
    title: "Edit market",
    layout: { type: "popover" },
    api: {
      initialValues: async (row) => {
        const data = readApiData(await marketsApi.getSingle(row.id));
        return (data && typeof data === "object" && !Array.isArray(data) ? data : {}) as Record<
          string,
          unknown
        >;
      },
      submit: async () => {},
    },
    structure: {
      type: "tabbed",
      savePerTab: true,
      tabs: [
        createMainTab(marketsApi),
        createPrematchTab(marketsApi),
        createLiveTab(marketsApi),
        createTranslationsTab({ ctx, marketsApi }),
        createOutcomesTab({ ctx, outcomesApi }),
        createFeedMappingTab(marketsApi),
        limitsTab,
        createConfigurationTab({ marketsApi }),
        createFeedConfigTab(marketsApi),
      ],
    },
  };
}
